import React from 'react';
import { ButtonProps, withStyles } from '@material-ui/core';
import FsButton from 'ui-elements/buttons/FsButton';

export const AddNewButton = withStyles(({ palette }) => ({
  root: {
    background: palette.grey[100],
  },
}))((props: ButtonProps) => <FsButton {...props} />);
